import { Image } from "@util/interfaces";
import * as React from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import Api from "@services/Api";
import { toastError, toastMessage } from "@util/functions";
import { BsTrash } from "react-icons/bs";
import styled from "styled-components";
import { ImageUrlModal } from "./components/UrlModal";

interface ImagesListProps {
  images: Image[];
  showUrlButton?: boolean;
}

const DeleteButton = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  background-color: #f54242;
  padding: 3px 5px;
  border-radius: 6px;
  opacity: 0.7;
  :hover {
    opacity: 1;
  }
`;

const ImagesList: React.FC<ImagesListProps> = ({ images, showUrlButton }) => {
  const [imagesList, setImagesList] = React.useState(images);
  const [isUrlModalOpen, setIsUrlModalOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState<Image | null>(null);

  const onSortEnd = async (oldIndex: number, newIndex: number) => {
    setImagesList((array) => arrayMoveImmutable(array, oldIndex, newIndex));
    const sortedImages = arrayMoveImmutable(imagesList, oldIndex, newIndex);
    if (sortedImages !== imagesList) {
      const prioritiesPayload = sortedImages.map((image, index) => ({
        image_id: image.id,
        priority: index,
      }));
      try {
        await Api.put(`/image/update_priority`, { payload: prioritiesPayload });
        toastMessage("Ordem atualizada", "success");
      } catch (error) {
        toastError(error);
      }
    }
  };

  const handleProductImageDelete = async (id: number) => {
    try {
      await Api.delete(`/image/${id}`);
      toastMessage("Imagem excluída", "success");
      setImagesList((array) => array.filter((image) => image.id !== id));
    } catch (error) {
      toastError(error, "error");
    }
  };

  React.useEffect(() => {
    setImagesList(images);
  }, [images]);

  React.useEffect(() => {
    if (selectedImage) {
      setIsUrlModalOpen(true);
    }
  }, [selectedImage]);

  return (
    <SortableList
      onSortEnd={onSortEnd}
      style={{
        display: "flex",
        flexWrap: "wrap",
        userSelect: "none",
        marginTop: 20,
        justifyContent: "space-evenly",
        width: "100%",
      }}
      draggedItemClassName={"dragged"}
    >
      {imagesList.map((image, index) => (
        <SortableItem key={image.id}>
          <div
            style={{
              position: "relative",
              cursor: "grab",
              userSelect: "none",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              marginBottom: 10,
            }}
          >
            <DeleteButton
              onClick={() => {
                handleProductImageDelete(image.id);
              }}
            >
              <BsTrash color={"white"} size={14} />
            </DeleteButton>
            <img
              style={{
                backgroundColor: "rgba(200,200,200,0.2)",
                height: 230,
                width: 200,
                pointerEvents: "none",
                objectFit: "contain",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              }}
              alt={"product"}
              className={"p-auto m-auto"}
              src={image.url?.replace("thumb_1", "thumb_3").replace("thumb_2", "thumb_3")}
            />
            {showUrlButton && (
              <div
                className="mb-1"
                style={{
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  className="btn btn-link"
                  style={{ backgroundColor: "rgba(255,255,255, 0.8)" }}
                  onClick={() => {
                    setSelectedImage(image);
                  }}
                >
                  <span>Alterar link</span>
                </button>
              </div>
            )}
          </div>
        </SortableItem>
      ))}
      {selectedImage && (
        <ImageUrlModal
          open={isUrlModalOpen}
          center
          image={selectedImage}
          onClose={() => {
            setSelectedImage(null);
          }}
        />
      )}
    </SortableList>
  );
};

export default ImagesList;
